<template>
  <div class="sp-item" :data-sp="sportsman.id"  v-bind:class="{'empty':sportsman.name =='' }" @click="clickSportsman()"
       @mouseenter="startPathHover()" @mouseleave="stopPathHover()"
       @touchstart.passive="startPathTouch()" @touchmove.passive="cancelPathTouch()" @touchend="cancelPathTouch()" @touchcancel="cancelPathTouch()"
       @contextmenu="onContextMenu">



    <div class="group-team group-team-top text-top-line ">
      <button v-if="sportsman.id" @click.stop="removeSportsman()" class="btn btn-sm btn-danger btn-fill" style="padding: 0px 5px;margin-left: -5px;margin-right: 5px;">x</button>
      <span
      class="tehnical-number">{{technicalNumber}}</span>
      <span style="
    background: #fff;
    z-index: 1000;
    position: relative;
" :title="isShortName ? sportsman.name : null">{{displayName}}</span>
      <span class="winner-points">{{sportsman.winPoints}}</span>
    </div>
    <div class="group-team group-team-top text-bottom-line"><span v-if="showOrganization">{{ [sportsman.oblast, sportsman.organization].filter(Boolean).join(' / ') }}</span></div>
    <div class="group-team group-team-top line-center"></div>
  </div>
</template>

<script>
  // скільки тримати мишку на спортсмені, щоб показати його шлях
  const PATH_HOVER_MS = 2000;
  // телефон/планшет: довге натискання
  const PATH_LONG_PRESS_MS = 600;

  export default {
    name: "bracket-sportsman-item-draw",
    props: {
      removeSportsmanBracket: {
        type: Function,
        description: "Function removeSportsmanBracket"
      },
      id: {
        type: [String,Number],
        description: "Sportsman id"
      },

      technicalNumber: {
        type: [String,Number],
        description: "Sportsman id"
      },

      sportsman: {
        type: [Object],
        description: "Sportsman object"
      },

      showOrganization: {
        type: [Boolean],
        description: "Sportsman object",
        default:false,
      },
      },
    computed:{
      activeTournamentId() {
        return this.$store.getters['settings/activeTournamentId'];
      },

      activeCategoryId() {
        return this.$store.getters['settings/activeCategoryId'];
      },

      activeBracketSize() {
        return this.$store.getters['settings/activeBracketSize'];
      },

      // повне ім'я — у першому колі, фіналі (1_x) і переможця (0_0); у проміжних колах — лише прізвище
      isShortName() {
        const line = Number(String(this.technicalNumber || '').split('_')[0]);
        const firstLine = Math.log2(Number(this.activeBracketSize) || 0);
        if (!Number.isInteger(firstLine) || isNaN(line)) return false;
        return line > 1 && line < firstLine;
      },

      // пара/команда "Іваненко Іван / Петренко Петро" → "Іваненко / Петренко"
      displayName() {
        const name = (this.sportsman && this.sportsman.name) || '';
        if (!this.isShortName) return name;
        return name.split('/').map(part => part.trim().split(/\s+/)[0]).filter(Boolean).join(' / ');
      },
    },

      beforeDestroy() {
        this.stopPathHover();
      },

      methods:{
        // шлях спортсмена: тримаємо мишку на імені ~2 с — підсвічуємо всі його місця в сітці,
        // поєдинки (номер + вертикальна лінія) і лінії під іменем. Стилі — _bracket-theme.scss
        canShowPath() {
          if (!this.sportsman || !this.sportsman.id || this.sportsman.id == 0) return false;
          // під час ручного жеребкування не заважаємо перетягуванню
          return !this.$el.classList.contains('sortable-drag-item');
        },
        startPathHover() {
          // після тапу браузер імітує mouseenter — на тач-пристроях шлях лише довгим натисканням
          if (this.lastTouchAt && Date.now() - this.lastTouchAt < 1000) return;
          this.stopPathHover();
          if (!this.canShowPath()) return;
          this.pathTimer = setTimeout(() => this.showPath(), PATH_HOVER_MS);
        },
        stopPathHover() {
          if (this.pathTimer) {
            clearTimeout(this.pathTimer);
            this.pathTimer = null;
          }
          if (this.pathTouchOff) {
            document.removeEventListener('touchstart', this.pathTouchOff, true);
            this.pathTouchOff = null;
          }
          if (!this.pathShown) return;
          this.pathShown = false;
          const root = this.pathRoot();
          root.classList.remove('has-sp-path');
          root.querySelectorAll('.sp-path, .group-path').forEach(el => el.classList.remove('sp-path', 'group-path'));
        },
        startPathTouch() {
          this.lastTouchAt = Date.now();
          this.suppressClick = false;
          this.stopPathHover();
          if (!this.canShowPath()) return;
          this.pathTimer = setTimeout(() => {
            this.showPath();
            if (!this.pathShown) return;
            // клік після довгого натискання не рахуємо як +1 бал
            this.suppressClick = true;
            if (navigator.vibrate) navigator.vibrate(15);
            // шлях лишається, доки не торкнуться екрана ще раз
            this.pathTouchOff = () => this.stopPathHover();
            document.addEventListener('touchstart', this.pathTouchOff, true);
          }, PATH_LONG_PRESS_MS);
        },
        // прокрутка або короткий тап — довге натискання скасовується
        cancelPathTouch() {
          this.lastTouchAt = Date.now();
          if (this.pathTimer) {
            clearTimeout(this.pathTimer);
            this.pathTimer = null;
          }
        },
        // меню браузера на довге натискання заважає — лише коли показали шлях
        onContextMenu(event) {
          if (this.suppressClick || this.pathShown) event.preventDefault();
        },
        showPath() {
          this.pathTimer = null;
          const root = this.pathRoot();
          const items = root.querySelectorAll('.sp-item[data-sp="' + this.sportsman.id + '"]');
          if (!items.length) return;
          items.forEach(el => {
            el.classList.add('sp-path');
            if (el.parentElement && el.parentElement.classList.contains('group')) el.parentElement.classList.add('group-path');
          });
          root.classList.add('has-sp-path');
          this.pathShown = true;
        },
        pathRoot() {
          return (this.$el && this.$el.closest('#bracket-image-block')) || document.body;
        },
        // клік по спортсмену поза ручним жеребкуванням — +1 виграний раунд (обробляє UserBracketsContructor)
        clickSportsman(){
          if (this.suppressClick) {
            this.suppressClick = false;
            return;
          }
          if (!this.sportsman || !this.sportsman.id || this.sportsman.id == 0) return;
          this.$root.$emit('bracket-sportsman-click', {position: String(this.technicalNumber), spId: this.sportsman.id});
        },
        removeSportsman(){

          if (window.confirm(" Видалити учасника з позиції ?")) {
            this.$store.dispatch('tournament/removeFromBracketSportsman', {id: this.sportsman.id, tournament_id:this.activeTournamentId, category_id:this.activeCategoryId, bracket_size:this.activeBracketSize, position:this.technicalNumber})
              .then(() => this.removedUpdate());
          }
        },
        removedUpdate(){

          this.$store.dispatch('tournament/fetchTournamentOneFull', {id: this.activeTournamentId})
              .then(() => this.$notify({
                group: 'foo',
                title: 'Дані оновлено',
                type: 'success',
              }));

        }
      }

  }
</script>

<style scoped>
.tehnical-number{
  display: none;
}

/* довге натискання на телефоні показує шлях — без виділення тексту і меню iOS */
@media (hover: none) {
  .sp-item {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;
  }
}

</style>
